import { render } from "./message-revoked.vue?vue&type=template&id=3276ba60&scoped=true&ts=true"
import script from "./message-revoked.vue?vue&type=script&lang=ts"
export * from "./message-revoked.vue?vue&type=script&lang=ts"

import "./message-revoked.vue?vue&type=style&index=0&id=3276ba60&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276ba60"]])

export default __exports__